import { useIcon } from '../../../hooks/useIcon';
import { Box } from '../../Box/Box';
import type { IconProps } from '../types';
import { IconSettingsSvg } from './IconSettingsSvg';

export const IconSettings: React.FC<IconProps> = (props) => {
  const iconProps = useIcon(props);
  return <Box component={IconSettingsSvg} {...iconProps} />;
};
